/**
 * The product's name in one place (D-1040). Mail templates (`apps/api/src/services/mail/templates.ts`
 * re-exports it), iCalendar output and public pages read it from here and never hard-code a name.
 * The name "Comsky Orbit" is decided, but the rename is a later wave: until then this stays the
 * current name, and the web app's `APP_TITLE` follows in that wave.
 */
export const PRODUCT_NAME = 'Comsky Orbit';

/**
 * PRODID of every VCALENDAR the Hub writes (RFC 5545 §3.7.3): `-//<PRODUCT_NAME>//Calendar 1.0//EN`.
 * Never another vendor's name (D-1040).
 */
export const ICS_PRODID = `-//${PRODUCT_NAME}//Calendar 1.0//EN`;

/** `X-WR-CALNAME` of a private feed: `<PRODUCT_NAME> · <name>` (§7.8). */
export function feedCalendarName(personName: string): string {
  return `${PRODUCT_NAME} · ${personName}`;
}
